module.exports = __webpack_public_path__ + "static/img/4445_phase_function_Paper_PointsHejduk_Prediction.686265a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4445_phase_function_Paper_PointsHejduk_Prediction.png
// module id = qIgn
// module chunks = 0